import { Locale } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { ApplicationLocale } from 'types/intl';

// Map of locale tags and their respective date-fns locale objects
export const dateFnsLocaleMap = new Map<ApplicationLocale, Locale>([['en-GB', enGB]]);

// Default locale object to use when formatting dates
export const defaultDateFnsLocale = enGB;
